module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"uk":{"publishDate":"Дата публікації","moreByAuthor":{"heading":"Інші новини компанії","link":"Всі новини"}},"en":{"publishDate":"Publish date","moreByAuthor":{"heading":"More company news","link":"See all"}}}')
  delete Component.options._Ctor
}
